// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"188":"ccedb964cd2b5d9f","3616":"db0c8724e1746541"}[chunkId] + ".css";
};